import { AccountDetail } from './AccountDetail';
import { ACCOUNT_ID } from './DetailPageRecords';

// The Account 360 demo is the account page, on one featured account.
export function AccountDetailMainSample() {
  return <AccountDetail id={ACCOUNT_ID} />;
}
